import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Formik, Form } from "formik";
import { MdError } from "react-icons/md";

import { useStyles } from "../../layout/Styles";
import * as Validate from "../../Validations";

const OutOfAreaPcpForm = React.memo(({ values, onSubmit }) => {
  const styles = useStyles();
  return (
    <Formik
      initialValues={{
        ...values,
      }}
      validationSchema={Validate.OoaPcpSchema}
      validateOnChange={true}
      onSubmit={async (values) => {
        onSubmit(values);
      }}
    >
      {({ values, setFieldValue, errors, touched, handleSubmit, isSubmitting, handleChange }) => {
        return (
          <Box pb={2} px={3}>
            <Form>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Box fontSize="25px" color="#0faf97">
                    {"Enter your PCP's information in the fields below"}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>PCP First Name</label>
                  <input
                    id="ooa-pcp-first-name"
                    aria-label="out of area pcp first name"
                    onChange={(e) => setFieldValue("first_name", e.target.value)}
                    disabled={isSubmitting}
                    name="first_name"
                    defaultValue={values.first_name}
                    className={styles.field}
                    placeholder="e.g. Jane"
                  />
                  {errors.first_name && touched && (
                    <div className="error">
                      <MdError /> {errors.first_name && errors.first_name}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>PCP Last Name</label>
                  <input
                    disabled={isSubmitting}
                    name="last_name"
                    defaultValue={values.last_name}
                    onChange={(e) => setFieldValue("last_name", e.target.value)}
                    aria-label="out of area pcp last name"
                    id="ooa-pcp-last-name"
                    className={styles.field}
                    placeholder="e.g. Robbins"
                  />
                  {errors.last_name && touched && (
                    <div className="error">
                      <MdError /> {errors.last_name && errors.last_name}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <label>PCP Practice Phone Number</label>
                  <input
                    id="ooa-pcp-phone-number"
                    onChange={(e) => setFieldValue("phone_number", e.target.value)}
                    aria-label="out of area pcp phone number"
                    name="phone_number"
                    disabled={isSubmitting}
                    defaultValue={values.phone_number}
                    className={styles.field}
                    placeholder="e.g. 7025334353"
                  />
                  {errors.phone_number && touched && (
                    <div className="error">
                      <MdError /> {errors.phone_number}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <label>PCP Practice Address</label>
                  <textarea
                    id="ooa-pcp-address"
                    name="address"
                    defaultValue={values.address}
                    aria-label="out of area pcp address"
                    disabled={isSubmitting}
                    style={{
                      fontSize: "1.025em",
                      fontWeight: "500",
                    }}
                    className={styles.field}
                    placeholder="e.g. 100 N. Green Valley Pkwy. Suite 239 Henderson NV 89074"
                  />
                </Grid>

                <Grid item xs={12} mb={2}>
                  <button
                    disabled={
                      isSubmitting || errors.first_name || errors.last_name || errors.phone_number
                    }
                    aria-label="submit pcp information"
                    type="submit"
                  >
                    {isSubmitting ? "...loading" : "Submit"}
                  </button>
                </Grid>
              </Grid>
            </Form>
          </Box>
        );
      }}
    </Formik>
  );
});

export default OutOfAreaPcpForm;
